import React from 'react';

type PDFViewerProps = {
  htmlContent: string;
  height: string;
  pdfTitle: string;
};

const PDFViewer: React.FC<PDFViewerProps> = (props): React.ReactElement => {
  const { htmlContent, height, pdfTitle } = props;

  if (!htmlContent) return <></>;

  return (
    <iframe
      srcDoc={htmlContent}
      width="100%"
      height={height}
      title={pdfTitle}
      style={{ border: '2px solid black' }}
    ></iframe>
  );
};

export default PDFViewer;
